module.exports = __webpack_public_path__ + "img/edbd152.png";